import { useMemo, useState } from 'react';

import { CryptoAsset } from '@/shared/modules/wallet/use-crypto-assets';

import { SortDir, SortKey } from './types';

export const useCryptoAssetsViewState = (assets: CryptoAsset[]) => {
  const [sortKey, setSortKey] = useState<SortKey>('usdValue');
  const [sortDir, setSortDir] = useState<SortDir>('desc');

  const sortedAssets = useMemo(
    () =>
      [...assets].sort((a, b) => {
        if (sortKey === 'symbol') {
          const comparison = a.symbol.toLowerCase().localeCompare(b.symbol.toLowerCase());
          return sortDir === 'asc' ? comparison : -comparison;
        }
        const comparison =
          sortKey === 'balance'
            ? (a.balance.comparedTo(b.balance) ?? 0)
            : (a.usdValue ?? -Infinity) - (b.usdValue ?? -Infinity);
        return sortDir === 'asc' ? comparison : -comparison;
      }),
    [assets, sortDir, sortKey],
  );

  const handleSort = (key: SortKey) => {
    if (key === sortKey) {
      setSortDir((direction) => (direction === 'asc' ? 'desc' : 'asc'));
      return;
    }
    setSortKey(key);
    setSortDir('desc');
  };

  return {
    sortKey,
    sortDir,
    sortedAssets,
    handleSort,
  };
};
